<template>
  <b-container class="pad-bottom--xl pad-top--sm">
      <hr class="separator"/>
      <h3>Report Suite</h3>
      <hr class="separator"/>
      <div class="mar-bottom--xl pad-bottom--xl">
        <div class="heading text--center mar-top--md mar-bottom--sm">Select Report Suite within Adobe Analytics</div>
          <multiselect
            class="select--multi"
            v-model="select_field_report"
            label="site_title"
            track-by="rsid"
            :options="report">
          </multiselect>
      </div>
      <div class="d-flex m-4 mar-bottom--xl pad-bottom--xl">
        <button class="ghost-button flex-grow-1" @click='cancel'>Cancel </button>
        <button class="purple-button purple-button--squished" @click="saveData()">Save & Close</button>
      </div>
      <hr class="separator"/>
      <div class="mar-bottom--xl pad-bottom--xl">
        <div class="heading text--center mar-top--md mar-bottom--sm">Customer Attributes FTP Credentials</div>
        <div class="heading text--center mar-top--md mar-bottom--sm">Last update: {{ftp.last_modified_date | formatDate}}</div>
        <b-alert show dismissible :class="checkClass" v-if="error">{{error}}</b-alert>
        <div class="flex flex--col">
          <input class="inline-textfield mar-y--sm" placeholder="Enter a host" type="text"  name="" :id="crmData.adobe_connection_id +'_host'"  v-model='ftp.host'>
          <input class="inline-textfield mar-y--sm" placeholder="Enter a username" type="text" name="" :id="crmData.adobe_connection_id + '_usernameFTP'"  v-model='ftp.username'>
          <input class="inline-textfield mar-y--sm" placeholder="Enter a password" type="password" name="" :id="crmData.adobe_connection_id +'_passwordFTP'" v-model='ftp.password'>
          <button class="ghost-button" @click='FtpCheck'>Check</button>
        </div>
        <div class="d-flex m-4 mar-bottom--xl pad-bottom--xl">
            <button class="ghost-button flex-grow-1" @click='cancel'>Cancel </button>
            <button class="purple-button purple-button--squished " @click="saveFtp()">Save & Close</button>
          </div>
      </div>
      <hr class="separator"/>
      <h3>Stitcher Import Logs</h3>
      <hr class="separator"/>
      <div v-for="(log, index) in logs" :key="index" style="text-align:left">
          <p v-b-toggle="'collapse_log' + index" class="expandable-trigger--log">
            <i class="expandable-trigger_indicator fas fa-caret-right"></i>
            <span class="expandable-trigger_text">{{log.create_date | formatDate}}</span>
          </p>
          <b-collapse :id="'collapse_log' + index" class="expandable-content_container--log">
              <div class="expandable-content--log">Successfully pushed {{log.imports}} from {{log.name}} into Adobe Analytics</div>
          </b-collapse>
      </div>
      <span class="flex flex-justify--start flex-items--left mar-top--lg">
        <button class="ghost-button" @click="$emit('deleteData')">Delete</button>
      </span>
  </b-container>
</template>
<script>
import AnalyticsReports from '@/api/Analytics/AnalyticsReport.js'
import Multiselect from 'vue-multiselect'

export default {
  name: 'AnalyticsMap',
  components: {
    Multiselect
  },
  props: {
    crmData: {
      type: Object
    },
    saveButtonText: {
      type: String
    }
  },
  data () {
    return {
      error: '',
      select_field_report: { 'rsid': '', 'site_title': '' },
      report: [],
      logs: [],
      ftp: {
        host: '',
        username: '',
        password: ''
      },
      message: '',
      checkClass: ''
    }
  },
  created () {
    this.getReport()
    this.getLogs()
    this.getFtp()
  },
  computed: {
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    FtpCheck () {
      var data = {
        'ftp_id': this.ftp.ftp_id,
        'adobe_connection_id': this.crmData.adobe_connection_id,
        'host': this.ftp.host,
        'username': this.ftp.username,
        'password': this.ftp.password
      }
      AnalyticsReports.checkFtp(data)
        .then(response => {
          if (response.error) {
            this.checkClass = 'error'
            this.error = response.error
          } else {
            this.checkClass = 'success'
            this.error = response.status
          }
        })
    },
    saveData () {
      var data = {
        'report_suite_id': this.select_field_report.rsid,
        'adobe_connection_id': this.crmData.adobe_connection_id
      }
      AnalyticsReports.saveReportSuites(data)
        .then(response => {
          if (response.status) {
            this.$emit('save', 'Report Saved')
          }
        })
    },
    saveFtp () {
      var data = {
        'ftp_id': this.ftp.ftp_id,
        'adobe_connection_id': this.crmData.adobe_connection_id,
        'host': this.ftp.host,
        'username': this.ftp.username,
        'password': this.ftp.password
      }
      this.ftpCheckAndSave(data)
    },
    reportSelect () {
    },
    getReport () {
      this.select_field_report.rsid = this.crmData.report_suite_id
      AnalyticsReports.getReportSuites(this.crmData.adobe_connection_id)
        .then(response => {
          response.forEach(res => {
            if (res.rsid === this.select_field_report.rsid) {
              this.select_field_report.site_title = res.site_title
            }
          })
          this.report = response
        })
    },
    ftpCheckAndSave (data) {
      AnalyticsReports.checkFtp(data)
        .then(response => {
          if (response.error) {
            this.error = response.error
          } else {
            this.error = ''
            AnalyticsReports.saveFtp(data)
              .then(response => {
                if (!response.error) {
                  this.$emit('save', response.status)
                }
              })
          }
        })
    },
    getFtp () {
      AnalyticsReports.getFtp(this.crmData.adobe_connection_id)
        .then(response => {
          this.ftp = response
        })
    },
    getLogs () {
      AnalyticsReports.analyticsImportLogs()
        .then(response => {
          this.logs = response
        })
    },
    handleScroll: function (evt) {
      if (window.scrollY > 50) {
      }
      return window.scrollY > 100
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
